import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { MaintenanceOverlay } from "@/components/App";
import { AccountLockedModal } from "@/components/Auth";
import { ErrorBoundary, Loading } from "@/components/UI";
import { appRouter } from "@/routes";

const App = () => (
  <ErrorBoundary>
    <HelmetProvider>
      <>
        <RouterProvider
          fallbackElement={<Loading fullScreen tip="Đang dựng storefront..." />}
          router={appRouter}
        />
        <AccountLockedModal />
        <MaintenanceOverlay />
      </>
    </HelmetProvider>
  </ErrorBoundary>
);

export default App;
